import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PublicHome',
    component: () => import('../views/public/PublicHome.vue')
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: () => import('../views/admin/Login.vue')
  },
  {
    path: '/admin',
    name: 'AdminLayout',
    component: () => import('../views/admin/AdminLayout.vue'),
    redirect: '/admin/contents',
    children: [
      {
        path: 'contents',
        name: 'ContentsManage',
        component: () => import('../views/admin/ContentsManage.vue'),
        meta: { title: '内容管理' }
      },
      {
        path: 'category',
        name: 'CategoryManage',
        component: () => import('../views/admin/CategoryManage.vue'),
        meta: { title: '分类管理' }
      },
      {
        path: 'account',
        name: 'AccountManage',
        component: () => import('../views/admin/AccountManage.vue'),
        meta: { title: '账号管理' }
      },
      {
        path: 'mainBusiness',
        name: 'MainBusinessManage',
        component: () => import('../views/admin/MainBusinessManage.vue'),
        meta: { title: '主营业务' }
      },
      {
        path: 'personalProfile',
        name: 'PersonalProfileManage',
        component: () => import('../views/admin/PersonalProfileManage.vue'),
        meta: { title: '个人简介' }
      },
      {
        path: 'titleSettings',
        name: 'TitleSettingsManage',
        component: () => import('../views/admin/TitleSettingsManage.vue'),
        meta: { title: '网站标题设置' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/admin/login')
      return
    }
  }
  next()
})

export default router
